import React, { memo } from 'react';

import Responsive from '@/components/Responsive';
import dynamic from '@/utils/dynamic';

import { SearchBarProps } from './types';

const SearchBarDesktop = dynamic(
  () => import(/* webpackChunkName: "searchbar-desktop" */ './index.desktop'),
);
const SearchBarMobile = dynamic(
  () => import(/* webpackChunkName: "searchbar-mobile" */ './index.mobile'),
);

const SearchBar: React.FC<SearchBarProps> = (props) => {
  return (
    <Responsive>
      <Responsive.Default>
        <SearchBarDesktop {...props} />
      </Responsive.Default>
      <Responsive.Mobile>
        <SearchBarMobile {...props} />
      </Responsive.Mobile>
    </Responsive>
  );
};

export default memo(SearchBar);
